<script setup lang="ts">
import { useBackPack, type BackpackItem } from '@/composables/game/backpack'
import { computed } from 'vue'
import InventorySlider from '@/components/InventorySlider.vue'
import { usePlayer } from '@/composables/game/player'
import { useMultiplayerMine } from '@/composables/game/multiplayer-mine'
import { suppressTooltips } from '@/composables/helpers/tooltip-suppressor'

const {
  essentials,
  collectibles,
  specialCollectibles,
  specials,
} = useBackPack()
const { canUseMines } = usePlayer()
const { openPlantMineModal, openUseMagnetOverlay } = useMultiplayerMine()

const backpackList = computed(() => [
  {
    title: 'Essentials',
    list: essentials.value,
    cardBgClass: 'bg-[linear-gradient(180deg,#F186FF_0%,rgba(202,20,23,0.66)_27%,rgba(199,249,0,0)_89%)]',
  },
  {
    title: 'Collectibles',
    description: 'Only live currencies show in your inventory.',
    list: collectibles.value,
    cardBgClass: 'bg-[linear-gradient(180deg,#B2FEFA_0%,rgba(14,210,247,0.66)_27%,rgba(138,35,135,0)_89%)]',
  },
  {
    title: 'Special Collectibles',
    list: specialCollectibles.value,
    cardBgClass: 'bg-[linear-gradient(180deg,#FAD961_0%,rgba(247,107,28,0.66)_54%,rgba(211,131,18,0)_89%)]',
  },
  {
    title: 'Specials',
    list: specials.value,
    cardBgClass: 'bg-[linear-gradient(180deg,#FAD961_0%,rgba(247,107,28,0.66)_55%,rgba(211,56,18,0)_89%)]',
  },
])

async function onItemClick(item: BackpackItem) {
  if (item.id === 'mp.mine') {
    if (!canUseMines.value) return
    suppressTooltips()
    openPlantMineModal()
    return
  }
  if (item.id === 'mp.mineMagnet') {
    suppressTooltips()
    openUseMagnetOverlay()
  }
}
</script>

<template>
  <div class="flex flex-col w-full items-center py-6 px-4">
    <img
      class="size-[120px] object-cover"
      src="@/assets/images/inventory-open.webp"
    >
    <div class="text-[32px] leading-[32px] font-bold text-light-white -mt-[22px]">
      Inventory
    </div>

    <div class="mt-10 w-full flex flex-col gap-y-3">
      <div
        v-for="(categoryGroup, index) in backpackList"
        class="flex flex-col gap-y-3"
        :key="index"
      >
        <template v-if="categoryGroup.list.length > 0">
          <div class="text-light-white text-[22px] leading-7 font-bold">
            <h2>{{ categoryGroup.title }}</h2>
            <p v-if="categoryGroup.description" class="text-light-white/70 text-sm font-semibold -tracking-[0.28px] mt-1">
              {{ categoryGroup.description }}
            </p>
          </div>
          <InventorySlider
            :items="categoryGroup.list"
            :card-bg-class="categoryGroup.cardBgClass"
            @item-click="onItemClick"
          />
        </template>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>
